"use client"

import { FC } from "react"
import type { RecommendedSearch } from "./types"
import { RecommendedSection, RecommendedHeading, ChipRow, Chip } from "./styles"

interface RecommendedSearchesProps {
  heading: string
  items: RecommendedSearch[]
  onSelect: (term: string) => void
}

const RecommendedSearches: FC<RecommendedSearchesProps> = ({
  heading,
  items,
  onSelect,
}) => {
  if (items.length === 0) return null

  return (
    <RecommendedSection>
      <RecommendedHeading>{heading}</RecommendedHeading>
      <ChipRow>
        {items.map((item, i) => (
          <Chip
            key={`${item.label}-${i}`}
            type="button"
            onClick={() => onSelect(item.term)}
          >
            {item.label}
          </Chip>
        ))}
      </ChipRow>
    </RecommendedSection>
  )
}

export default RecommendedSearches
